import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const WhyChooseUsSection = ({ onOpenContactForm }) => {
  const section = useScrollAnimation({ threshold: 0.1 });
  return (
    <section data-testid="why-choose-section" className="py-24 md:py-32 bg-[#093336]/20 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className={`scroll-slide-left ${section.isVisible ? 'scroll-visible' : ''}`} ref={section.ref}>
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1758519288495-5f79a4bbab83?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjBhdHRvcm5leSUyMGNvbnN1bHRhdGlvbiUyMG9mZmljZXxlbnwwfHx8fDE3NzYyNzc2NjR8MA&ixlib=rb-4.1.0&q=85"
                alt="Attorney consultation"
                className="w-full h-[400px] lg:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#041B1C]/50 to-transparent" />
            </div>
          </div>

          <div className={`scroll-slide-right ${section.isVisible ? 'scroll-visible' : ''}`}>
            <span className="inline-block bg-[#A5BF23]/10 text-[#A5BF23] px-4 py-1.5 rounded-full text-xs font-bold tracking-[0.2em] mb-6">WHY CHOOSE US</span>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#F0F4F4] leading-tight mb-6" style={{ fontFamily: "'Outfit', sans-serif" }}>
              Why Businesses Trust Us With Their Brand Names
            </h2>
            <p className="text-base text-[#A0B2B2] leading-relaxed mb-8">
              Thousands of business owners have registered their brand names through us because we make the process simple, affordable, and reliable. Our bar-admitted trademark attorneys handle every filing with precision, flat-rate pricing starts at just $49, and most applications are submitted to the USPTO within 48 hours. You get a dedicated case specialist, real-time updates, and full office action defense if the USPTO pushes back. From coast to coast, we protect brand names in all 50 states.
            </p>
            <Button data-testid="why-choose-cta" onClick={onOpenContactForm}
              className="bg-[#A5BF23] hover:bg-[#8A9F1D] text-[#041B1C] font-semibold px-8 h-11 text-sm rounded-full transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_32px_rgba(165,191,35,0.3)]">
              Protect My Brand Name <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
